angular.module('statVehicleCount', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/stat-vehicle-count/stat-vehicle-count.module.js